var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{class:_vm.progressBarClass,attrs:{"value":_vm.value,"height":"20","color":_vm.color},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('strong',[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }